import { CareOrder, type ICareOrder } from '@talos/kyoko';

export interface SelectableCareOrderSelectionState {
  /** If the care order is currently selected */
  selected: boolean;
  /** If the care order has been selected at any point in the dialog's open session */
  hasBeenSelected: boolean;
  /** If modifying, if the care order is a constituent member of the current netted care order */
  inNettedOrder?: boolean;
}

/**
 * SelectableCareOrder is used as the (blotter) entity for netting purposes to keep track of
 * selection and modification-related status. The extra attributes are used for diffing against a proposed modification,
 * filtering rows into and out of the blotter, etc.
 */
export class SelectableCareOrder extends CareOrder {
  isSelected: boolean;
  hasBeenSelected: boolean;
  inNettedOrder: boolean;

  constructor(
    data: CareOrder | ICareOrder,
    selectionState: SelectableCareOrderSelectionState = { selected: false, hasBeenSelected: false }
  ) {
    super(data);
    this.isSelected = selectionState.selected;
    this.hasBeenSelected = selectionState.hasBeenSelected;
    this.inNettedOrder = selectionState.inNettedOrder ?? false;
  }
}
